<template>
  <div>
    <v-snackbar v-model="snackbar" bottom left :timeout="4000">{{ snackbarText }}</v-snackbar>
    <v-row>
      <v-col lg="12" md="12" sm="12">
        <AoTable
          :headers="aoHeaders"
          :items="aos"
          :title="'Awarding Organisation'"
          :modalText="'Ao'"
          :apiRoute="'ao'"
          @optionAdded="onOptionAdded"
        />
      </v-col>
      <v-col lg="12" md="12" sm="12">
        <CertificationsTable
          :headers="pendingCertificationsHeaders"
          :items="pendingCertifications"
          :title="'Certification Requests'"
          :isLoading="isPendingCertificationsLoading"
        />
      </v-col>
      <v-col lg="12" md="12" sm="12">
        <PendingUnitsTable
          :headers="pendingUnitsHeaders"
          :items="pendingUnits"
          :title="'Unit Registration Requests'"
          :isLoading="isPendingUnitsLoading"
        />
      </v-col>
      <v-col lg="12" md="12" sm="12">
        <PendingQualificationsTable
          :headers="pendingQualificationsHeaders"
          :items="pendingQualifications"
          :title="'Qualification Registration Requests'"
          :isLoading="isPendingQualificationsLoading"
        />
      </v-col>
      <v-col lg="12" md="12" sm="12">
        <PendingLearnersTable
          :headers="pendingLearnersHeaders"
          :items="unduplicatedLearners"
          :title="'Learner Registration Requests'"
          :isLoading="isPendingLearnersLoading"
        />
      </v-col>
      <v-col lg="12" md="12" sm="12">
        <PendingLearnersTable
          :headers="pendingLearnersHeaders"
          :items="[]"
          :title="'AO Registration Requests'"
          :isLoading="isPendingLearnersLoading"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PendingUnitsTable from "./PendingUnitsTable";
import PendingQualificationsTable from "./PendingQualificationsTable";
import PendingLearnersTable from "./PendingLearnersTable";
import CertificationsTable from "./CertificationsTable";
import AoTable from "../components/AoTable";

export default {
  mounted: function () {
    this.getPendingUnits();
    this.getPendingQualifications();
    this.getPendingLearners();
    this.getPendingCertifications();
    this.getAo();

    if (this.$route.params.message) {
      this.onOptionAdded({ message: this.$route.params.message });
    }
  },
  components: {
    PendingUnitsTable,
    PendingQualificationsTable,
    PendingLearnersTable,
    CertificationsTable,
    AoTable,
  },
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      aos: [],
      isPendingUnitsLoading: true,
      isPendingQualificationsLoading: true,
      isPendingLearnersLoading: true,
      isPendingCertificationsLoading: true,
      pendingUnits: [],
      pendingQualifications: [],
      pendingLearners: [],
      pendingCertifications: [],
      pendingUnitsHeaders: [
        {
          text: "Centre Name",
          align: "start",
          sortable: false,
          value: "centreName",
        },
        { text: "Unit Name", value: "unitName" },
      ],
      pendingQualificationsHeaders: [
        {
          text: "Centre Name",
          align: "start",
          sortable: false,
          value: "centreName",
        },
        { text: "Qualification Name", value: "qualificationName" },
      ],
      pendingLearnersHeaders: [
        {
          text: "Centre Name",
          align: "start",
          sortable: false,
          value: "centreName",
        },
        { text: "Learner Name", value: "learnerName" },
        { text: "Request Date", value: "createdAt" },
      ],
      pendingCertificationsHeaders: [
        {
          text: "Centre Name",
          align: "start",
          sortable: false,
          value: "centreName",
        },
        { text: "Learner Name", value: "learnerName" },
        { text: "Status", value: "status" },
        { text: "Request Date", value: "createdAt" },
      ],
    };
  },
  computed: {
    aoHeaders: function () {
      return [
        {
          text: "Code",
          align: "start",
          sortable: false,
          value: "code",
        },
        { text: "Name", value: "name" },
        { text: "City", value: "city" },
        {
          text: "First Approved Date",
          value: "firstApprovedDate",
        },
        { text: "Renewal Date", value: "renewalDate" },
        { text: "Status", value: "status" },
        {
          text: this.$t("table.actions"),
          value: "actions",
          align: "end",
          sortable: false,
        },
      ];
    },
    unduplicatedLearners: function () {
      const learnerList = [];

      for (let i = 0; i < this.pendingLearners.length; i++) {
        let duplicate = false;
        for (let j = 0; j < learnerList.length; j++) {
          if (this.pendingLearners[i].code == learnerList[j].code) {
            duplicate = true;
            break;
          }
        }

        if (!duplicate) {
          learnerList.push(this.pendingLearners[i]);
        }
      }

      return learnerList;
    },
  },
  watch: {
    isPendingUnitsLoading: function (newValue) {
      this.isPendingUnitsLoading = newValue;
    },
    isPendingQualificationsLoading: function (newValue) {
      this.isPendingQualificationsLoading = newValue;
    },
    isPendingLearnersLoading: function (newValue) {
      this.isPendingLearnersLoading = newValue;
    },
    isPendingCertificationsLoading: function (newValue) {
      this.isPendingCertificationsLoading = newValue;
    },
  },
  methods: {
    getAo: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/ao`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.aos = data.aos;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getPendingUnits: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/units/pending`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.isPendingUnitsLoading = false;
          this.pendingUnits = data.pendingUnits;
          console.log("Data" + data);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getPendingQualifications: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/qualifications/pending`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.isPendingQualificationsLoading = false;
          this.pendingQualifications = data.pendingQualifications;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getPendingLearners: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/learners/pending`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.isPendingLearnersLoading = false;
          this.pendingLearners = data.pendingLearners;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getPendingCertifications: function () {
      fetch(`${process.env.VUE_APP_ROOT_API}/certifications/pending`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          this.isPendingCertificationsLoading = false;
          this.pendingCertifications = data.certifications || [];
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onOptionAdded: function (data) {
      this.getAo();

      this.snackbarText = data.message;
      this.snackbar = true;
    },
  },
};
</script>

<style scoped>
</style>
